export enum ChainItemType {
    PAST, CURRENT, FUTURE
}